import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'pur-order-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'pur-order-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'pur-order-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'pur-order-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'pur-order-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'pur-order-overview__activity--marketing-list',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'client',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'document',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = [
    'invoice_third',
    'estimate_third',
    'turnover_third',
    'top_selling_items_third',
    'sales_margin_third',
];

const databots = {
    activity: 'pur-order-overview__menu--activity',
    informations: 'pur-order-overview__menu--general-info',
    financialactivity: 'pur-order-overview__menu--financial-info',
    contacts: 'pur-order-overview__menu--contact-linked',
    addresses: 'pur-order-overview__menu--address',
    customfields: 'pur-order-overview__menu--cf',
    statistics: 'pur-order-overview__menu--stat',
    opportunity: 'pur-order-overview__menu--opportunity',
    estimate: 'pur-order-overview__menu--document',
    invoice: 'pur-order-overview__menu--document',
    delivery: 'pur-order-overview__menu--document',
    order: 'pur-order-overview__menu--document',
    creditnote: 'pur-order-overview__menu--document',
    proforma: 'pur-order-overview__menu--document',
    payments: 'pur-order-overview__menu--payment',
    bankaccount: 'pur-order-overview__menu--bank-account',
    recurring: 'pur-order-overview__menu--recurring',
    mandates: 'pur-order-overview__menu--mandate',
    timetracking: 'pur-order-overview__menu--timetracking',
    tickets: 'pur-order-overview__menu--ticket',
    project: 'pur-order-overview__menu--project',
    proposal: 'pur-order-overview__menu--proposal',
    emailingprofile: 'pur-order-overview__menu--mailing-list',
    massmailingMailinglist: 'pur-order-overview__menu--mailing-list',
    massmailingCampaignList: 'pur-order-overview__menu--mailing-list',
    receipts: 'pur-order-overview__menu--receipt',
    briefcase: 'pur-order-overview__menu--briefcase',
    activitycommentadd: 'pur-order-overview__activity--comment-add',
    emailadd: 'pur-order-overview__activity--email-add',
    calladd: 'pur-order-overview__activity--call-add',
    taskadd: 'pur-order-overview__activity--task-add',
    eventadd: 'pur-order-overview__activity--event-add',
    generalinfoedit1: 'pur-order-overview__section--general-info-edit-1',
    generalinfoedit2: 'pur-order-overview__section--general-info-edit-2',
    marketing: 'pur-order-overview__section--marketing',
};

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesTabs,
    defaultEntities,
    entitiesGroups,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
